module.exports = __webpack_public_path__ + "img/Feature.a9af8512.jpg";